import Vue from "vue";
import { getUrlParam, setCookie, removeUrlParameter, getOSType, checkClientIsOpen } from "_lib/utils/utils";
import VueRouter from "vue-router";
import MainLayout from '../layout/MainLayout.vue'
const Home = () => import('../views/home/index.vue')
const Room = () => import('../views/room/index.vue')
const Invite = () => import('../views/invite/index.vue')
const InviteRedirect = () => import('../views/invite-redirect/index.vue')
const TeamCenter = () => import('../views/team-center/index.vue')
const PubgReport = () => import('../views/game-function/pubg/video-report/index.vue')
const ActAccSpell = () => import('../views/activity/acc-spell-2308/index.vue')
const CrosshairRedirect = () => import('../views/crosshair-redirect/index.vue')
const MiniprogramPlatform = () => import('../views/home/homeContent/MainContent/MiniprogramPlatform.vue')
const Friends = () => import('../views/friends/index.vue')
const ChatGroupInvite = () => import('../views/group-invite/index.vue')

let WebRoute = [];
if (!process.env.IS_CLIENT) {
  WebRoute = [
    {
      path: "/protocol/privacy",
      name: "protocol_private",
      component: () => import('../views/protocol/private.vue'),
    },
    {
      path: "/protocol/person",
      name: "protocol_person",
      component: () => import('../views/protocol/person_table.vue'),
    },
    {
      path: "/protocol/third",
      name: "protocol_third",
      component: () => import('../views/protocol/third_table.vue'),
    },
    {
      path: "/protocol/user",
      name: "protocol_user",
      component: () => import('../views/protocol/user.vue'),
    },
    {
      path: "/protocol/community",
      name: "protocol_community",
      component: () => import('../views/protocol/community.vue'),
    },
    {
      path: "/protocol/screen_share_pay",
      name: "protocol_screen_share_pay",
      component: () => import('../views/protocol/screenPay.vue'),
    },
    {
      name: "bot-admin",
      path: "/bot-admin",
      component: () => import("@/views/bot/admin.vue"),
    },
    {
      name: "bot-admin-room",
      path: "/bot-admin/room",
      component: () => import("@/views/bot/components/Room.vue"),
    },
    {
      path: '/obs-overlay'
    },
    {
      path: '/obs-overlay/voice/:room_id/:channel_id'
    }
  ];
}

import { getPkeyWithToken } from "_api/login"
import { reportData, reportLogin } from '_api/report'

Vue.use(VueRouter);

const routes = [
  {
    path: "/app",
    name: 'main',
    component: MainLayout,
    beforeEnter: (to, from, next) => {
      next()
    },
    children: [
      {
        path: "",
        name: "home",
        component: Home,
        meta: {
          showFriendSideBar: true,
          showDownloadBanners: true,
          showVoicePanel: true,
        }
      },
      {
        path: "room/:room_id",
        name: "room",
        component: Room,
        meta: {
          showFriendSideBar: true,
          showVoicePanel: true,
        }
      },
      {
        path: "/friends",
        name: "friends",
        component: Friends,
        meta: {
          showFriendSideBar: false,
          showDownloadBanners: false,
          showVoicePanel: true,
        }
      },
      {
        path: 'team-center',
        name: 'team-center',
        component: TeamCenter,
        meta: {
          showVoicePanel: true,
          hiddenPrivateChat: true,
        }
      },
      {
        path: 'pubg/video-report',
        name: 'pubg-video-report',
        component: PubgReport,
        meta: {
          hiddenPrivateChat: true,
        }
      },
      {
        path: "/activity/acc_spell",
        name: 'acc-spell',
        component: ActAccSpell,
        meta: {
          hiddenPrivateChat: true,
        }
      },
      {
        path: '/mini-program',
        name: 'mini-program',
        component: MiniprogramPlatform,
        meta: {
          hiddenPrivateChat: true,
          showVoicePanel: true,
        }
      }
    ]
  },
  {
    path: '/:invite_code(\\d+|[iIjJ]\\w+)',
    name: 'invite', // 如果有改动，请搜索this.$route.name !== 'invite'
    component: Invite,
    beforeEnter: (to, from, next) => {
      const osType = getOSType()
      const isMobile = ['iOS', 'Android'].includes(osType)
      const inviteCode = to.params.invite_code
      
      const isGroupInvite = /^[jJ]\w+$/.test(inviteCode)
      
      if (!isMobile && isGroupInvite) {
        next({
          name: 'chat-group-invite',
          params: { chatGroupInviteCode: inviteCode },
          query: to.query
        });
      } else {
        next();
      }
    }
  },
  {
    path: '/:chatGroupInviteCode(\\d+|[jJ]\\w+)',
    name: 'chat-group-invite',
    component: ChatGroupInvite
  },
  {
    path: '/invite-redirect/:invite_code(\\d+|[iI]\\w+)',
    name: 'invite-redirect',
    component: InviteRedirect
  },
  {
    path: "/login",
    name: 'login',
    redirect: '/app/'
  },
  {
    path: '/:crosshair_share_code(ch\\w+)',
    name: 'crosshair-share',
    component: CrosshairRedirect
  },
  {
    path: '*',
    redirect: '/app/'
  },
  ...WebRoute,
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: process.env.IS_CLIENT ? "hash" : "history",
  routes,
});

let _isTokenUsed = false;
router.beforeEach(async (to, from, next) => {
  let origin = getUrlParam('origin')
  if (to.query.web_token && !_isTokenUsed) {
    const isClientOpen = await checkClientIsOpen(to.params.invite_code, to.query.web_token);
    if (!isClientOpen) {
      try {
        let {data: { status, result }} = await getPkeyWithToken({
          token: to.query.web_token,
          _notip: 1
        })
        if (status === 'ok' && result.error === "ok") {
          _isTokenUsed = true
          reportLogin('token', {
            origin
          })
        }
        if (status === 'ok') {
          setCookie('heybox_id', result.heyboxid);
          setCookie('user_heybox_id', result.heyboxid);
          setCookie('avatar', result.avatar);
          setCookie('nickname', result.nickname);
          const url = window.location.href;
          const newUrl = removeUrlParameter(url, 'web_token');
          window.history.replaceState({}, '', newUrl);
        }
      } catch (e) {}
    }
  }
  if (origin) {
    reportData('enter-chat', {
      origin
    })
  }
  // 如果是obs-overlay，则跳转到obs
  if (to.path.startsWith('/obs-overlay')) {
    function buildUrl(basePath, queryParams) {
      let url = basePath;
    
      // 检查是否有查询参数对象，并且它不是空的
      if (queryParams && Object.keys(queryParams).length > 0) {
        const queryString = Object.keys(queryParams)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
          .join('&');
        url += `?${queryString}`;
      }
    
      return url;
    }
    const newOrigin = process.env.IS_PROD ? 'https://chat.xiaoheihe.cn' : 'http://localhost:3000'
    const newPath = to.path.replace('/obs-overlay', '/obs');
    const newUrl = buildUrl(`${newOrigin}${newPath}`, to.query);
    window.location.href = newUrl;
  } else {
    next();
  }
})

export default router;
